import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
// import { db } from '@utils/wmIndexDB';
import KangarooTip from './KangarooTip';
import PoiDropMenu from './PoiDropMenu';
import { RootState } from '../../../../store';
// import { getAllPoiList } from '../../../../api'
import { IKangarooInfo, KangarooStatus } from '../../../../api/define';
import styles from './PoliList.module.scss';
import menuStyles from './PoiDropMenu.module.scss';

const { useEffect } = React;

type PoliListProps = {
    /** 袋鼠店长信息 */
    kangarooInfo: IKangarooInfo;
    /**
     * 当前账号是否关联了多个门店
     * 0：当前账号只绑定了1个门店（200账号 or 300账号但是只有1个门店）
     * 1：300账号且绑定了多个门店
     * */
    isChain: 0 | 1;
    /** 门店名 */
    wmPoiName: string;
    /** 获取所有门店列表 */
    getPoiKangarooInfo: () => void;
};

/** head - 门店列表 */
const PoliList: React.FC<PoliListProps> = ({
    kangarooInfo,
    isChain,
    wmPoiName,
    getPoiKangarooInfo,
}) => {
    useEffect(() => {
        getPoiKangarooInfo();
    }, []);

    return (
        <div className={styles.container}>
            {/** 袋鼠店长信息 */
            kangarooInfo.status === KangarooStatus.UNEXPIRE ||
            kangarooInfo.status === KangarooStatus.EXPIRE ? (
                <KangarooTip info={kangarooInfo} />
            ) : null}

            {/* 门店下拉列表 */}
            {isChain === 0 ? (
                <div className={menuStyles.currentPoi} title={wmPoiName}>
                    <span className={menuStyles.txt}>{wmPoiName}</span>
                </div>
            ) : (
                <PoiDropMenu />
            )}
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        kangarooInfo: state.shellHeader.poiKangarooInfo,
        isChain: state.shellCommon.isChain,
        wmPoiName: state.shellCommon.wmPoiName,
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    getPoiKangarooInfo: () => {
        dispatch({ type: 'shellHeader/getPoiKangarooInfo' });
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(PoliList);
